module.exports = __webpack_public_path__ + "static/media/dansko-foods.ad6eacd5.jpg";